import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { Hr } from "@irati/ui/src/Layout";
import { Body } from "@irati/ui/src/Typography";
import Spacing from "@irati/ui/src/Spacing";
import ListItem from "./ListItem";
var OccasionsTab = function (_a) {
    var items = _a.items, description = _a.description, hide = _a.hide, show = _a.show, edit = _a.edit;
    return (React.createElement(React.Fragment, null,
        description &&
            React.createElement(Spacing, { marginTop: 4, marginBottom: 4 },
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: description }))),
        items.map(function (item, i) { return (React.createElement("div", { key: i },
            i !== 0 && i !== items.length && React.createElement(Hr, null),
            React.createElement(ListItem, { item: item, hide: hide, show: show, edit: edit }))); })));
};
export default OccasionsTab;
